module.exports = __webpack_public_path__ + "static/media/watern32_3.ff5949a9.png";